import { isCaseViewModalEnabled } from "app/infrastructure/hosting";
import { routeConstants } from "app/routes/route-constants";

export const isMobileScreen = () => {
  const MOBILE_SCREEN_WIDTH: number = 425;
  return window.innerWidth < MOBILE_SCREEN_WIDTH;
};

export const isWindowLargeEnough = () => {
  const LARGE_WINDOW_WIDTH: number = 1350;
  return window.innerWidth > LARGE_WINDOW_WIDTH;
};

export const dropdownRefContextMenu = (subMenuRef: HTMLUListElement) => {
  if (subMenuRef) {
    if (isMobileScreen()) {
      return;
    }
    if (!isWindowLargeEnough()) {
      subMenuRef.style.left = 'auto';
      subMenuRef.style.right = '100%';
      subMenuRef.style.top = '-10px';
    } else {
      subMenuRef.style.left = '100%';
      subMenuRef.style.right = 'auto';
      subMenuRef.style.top = '-10px';
    }
  }
};

export const isCaseViewModalOpen = () => {
  return !!document.getElementById("caseViewModal");
};

export const shouldNavigateToModal = (isCaseReport?: boolean, isDashboard?: boolean, isBowtie?: boolean ) => {
  return isCaseViewModalEnabled() && (isCaseReport || isDashboard || isBowtie);
};

export const addOrReplaceQueryParams = (
  searchParams: Record<string, string> | URLSearchParams,
  newParams: Record<string, string>    
): string => {  
  const updatedParams = new URLSearchParams(searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams));

  for (const [key, value] of Object.entries(newParams)) {
    updatedParams.set(key, value);
  }
  return `?${updatedParams.toString()}`;
};

export const getUrlOpenCase = (caseId: number, pathName?: string, searchParams?: URLSearchParams): string => {
  if (isCaseViewModalEnabled()) {
    const pathWithoutTrailingSlash = pathName?.endsWith('/') ? pathName?.slice(0, -1) : pathName;
    return `${pathWithoutTrailingSlash}/case/${caseId}${addOrReplaceQueryParams(searchParams, {})}`;
  }
  return caseId ? routeConstants.caseViewFor(caseId) : '';
};
